import DecryptageArticleModel from './DecryptageArticle.model';

export default class PedagogicPageContent {
  constructor({
    title,
    infox,
    decoding,
    dictionnary,
  }) {
    this.title = title;
    this.infox = infox;
    this.decoding = decoding;
    this.wording = dictionnary.wordings;
  }

  getPageTitle() {
    return this.wording.title_pedagogie || 'A qui se fier ?';
  }

  getTrustTitle() {
    return this.title || 'A qui se fier ?';
  }

  getInfoxTitle() {
    return this.infox.title || '';
  }

  getInfoxContent() {
    return this.infox.text || '';
  }

  getInfoxImage() {
    return this.infox.image || '';
  }

  getInfoxLinks() {
    return this.infox?.links ? Object.values(this.infox.links) : [];
  }

  getDecodingTitle() {
    return this.wording.title_fakenews_decryptage || '';
  }

  getDecodingArticles() {
    const articles = this.decoding?.nodes ? Object.values(this.decoding.nodes) : [];
    return articles.map((val) => new DecryptageArticleModel(val));
  }
}
